export default __webpack_public_path__ + "static/media/portfolio-hover-155.f3b50071.jpg";